import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Grid, Image } from "semantic-ui-react";
import { Header } from "../common";
import DealRate from "../../components/DealRate";
import RatesTable from "../RatesTable/RatesTable";
import styles from "./styles.less";

class DealsRatesGroup extends Component {
  state = {
    appearRates: true,
    rateSelected: false
  };

  componentDidMount() {
    const { onDealRatesShow, getAnalyticsPlaceHolders } = this.props;
    setTimeout(onDealRatesShow, 0);
    getAnalyticsPlaceHolders && getAnalyticsPlaceHolders();
  }

  componentWillUnmount() {
    const { clearAnalyticsPlaceHolders } = this.props;
    clearAnalyticsPlaceHolders && clearAnalyticsPlaceHolders();
  }

  onRateSelection = ({ ...rateSelectedParams }) => {
    // dispatch global event of roomselected
    const event = new CustomEvent("__be_roomSelected", {
      detail: {
        roomId: rateSelectedParams.roomId
      }
    });
    window.dispatchEvent(event);

    this.setState({ rateSelected: true });
    const { onRateSelection } = this.props;
    onRateSelection({ ...rateSelectedParams });
  };

  renderRate = (rate, image, roomId, oldPrice, roomName, deal) => {
    const {
      titles,
      isRtl,
      isMobileView,
      showClubPrices,
      showAvailability,
      onRateReadMore,
      ShowCancellationPolicy,
      showSimpleClubLoginModal,
      clubUserLoggedIn,
      onShowRoomGalleryPopUp,
      isIE
    } = this.props;

    return (
      <Grid.Column
        key={rate.id}
        mobile={16}
        tablet={8}
        computer={4}
        className={cx({ [styles.rateWrapper]: !isMobileView })}
      >
        <DealRate
          isRtl={isRtl}
          titles={titles}
          rateId={rate.id}
          planName={rate.planName}
          titleName={roomName}
          price={rate.totalPrice}
          priceCode={rate.priceCode}
          planCode={rate.planCode}
          availability={rate.availability}
          showAvailability={showAvailability}
          description={rate.planDescription}
          onClick={this.onRateSelection}
          onRateReadMore={onRateReadMore}
          ratePriceAfterDiscount={rate.simpleClubTotalPrice}
          showClubPrices={showClubPrices}
          clubUserLoggedIn={clubUserLoggedIn}
          ShowCancellationPolicy={ShowCancellationPolicy}
          showSimpleClubLoginModal={showSimpleClubLoginModal}
          onShowRoomGalleryPopUp={onShowRoomGalleryPopUp}
          isMobileView={isMobileView}
          image={image}
          roomId={roomId}
          oldPrice={oldPrice}
          isIE={isIE}
          room={deal}
        />
      </Grid.Column>
    );
  };

  renderRateImage = imageSrc => {
    return (
      <Grid.Column
        only="computer"
        width={8}
        className={styles.priceImageWrapper}
        verticalAlign="top"
      >
        <Image
          size="huge"
          bordered
          verticalAlign="bottom"
          className={styles.priceImage}
          src={imageSrc}
        />
      </Grid.Column>
    );
  };

  renderRoomsAsTables = data => {
    const {
      showClubPrices,
      isRtl,
      titles,
      selectedPaxId,
      ShowCancellationPolicy,
      isClubActive,
      clubUserLoggedIn,
      clubPercentageDiscount,
      onRateReadMore,
      onShowRoomGalleryPopUp,
      isIE
    } = this.props;

    return (
      <RatesTable
        groupParam={"roomId"}
        titleParam={"name"}
        showClubPrices={showClubPrices}
        isRtl={isRtl}
        titles={titles}
        rates={data}
        selectedPaxId={selectedPaxId}
        onItemClick={this.onRateSelection}
        onReadeMoreClick={onRateReadMore}
        ShowCancellationPolicy={ShowCancellationPolicy}
        isClubActive={isClubActive}
        clubUserLoggedIn={clubUserLoggedIn}
        clubPercentageDiscount={clubPercentageDiscount}
        isIE={isIE}
        onShowRoomGalleryPopUp={onShowRoomGalleryPopUp}
        viewGallery={true}
        isDealPage={true}
      />
    );
  };

  renderRatesAsGroups = data => {
    if (data && data.length >= 1) {
      return data.map((deal /*, rowIndex*/) => {
        return (
          //<React.Fragment key={rowIndex}>
          this.renderRate(
            deal.rate,
            deal.imageUrl,
            deal.roomId,
            deal.oldPrice,
            deal.name,
            deal
          )
          //</React.Fragment>
        );
      });
    } else {
      return (
        //<React.Fragment key={rowIndex}>
        this.renderRate(
          data.rate,
          data.imageUrl,
          data.roomId,
          data.oldPrice,
          data.name,
          data
        )
        //</React.Fragment>
      );
    }
  };

  render() {
    const {
      titles,
      selectedPaxId,
      showRoomNumberTitle,
      isMobileView,
      isRtl,
      deals
    } = this.props;
    const headerText = showRoomNumberTitle
      ? `${titles.PleaseSelectRoomNumber} ${selectedPaxId + 1} :`
      : `${titles.PleaseSelectRoom}`;
    //const fadeIn = deals.length > 0;
    return (
      <Grid
        className={cx(styles.flexColumn, {
          [styles.flexColumnMobileView]: isMobileView
        })}
        id={selectedPaxId + "dealRatesGroup"}
      >
        <Grid.Row>
          <Header
            className={styles.ratesGroupTitle}
            text={headerText}
            isRtl={isRtl}
            isMobileView={isMobileView}
            noPadding={true}
          />
        </Grid.Row>
        {isMobileView
          ? deals.map((data, key) => (
              <Grid.Row className={cx(styles.resultsWrapper)} key={key}>
                {this.renderRatesAsGroups(data, key)}
              </Grid.Row>
            ))
          : this.renderRoomsAsTables(deals)}
      </Grid>
    );
  }
}

DealsRatesGroup.propTypes = {
  isRtl: PropTypes.bool,
  isMobileView: PropTypes.bool,
  titles: PropTypes.object,
  showAvailability: PropTypes.bool,
  onRateReadMore: PropTypes.func,
  showClubPrices: PropTypes.bool,
  ShowCancellationPolicy: PropTypes.bool,
  isIE: PropTypes.bool,
  deals: PropTypes.array,
  onRateSelection: PropTypes.func,
  clubUserLoggedIn: PropTypes.bool,
  showSimpleClubLoginModal: PropTypes.func,
  selectedPaxId: PropTypes.number,
  showRoomNumberTitle: PropTypes.bool,
  onShowRoomGalleryPopUp: PropTypes.func,
  onDealRatesShow: PropTypes.func,
  isClubActive: PropTypes.bool,
  clubPercentageDiscount: PropTypes.number,
  getAnalyticsPlaceHolders: PropTypes.func,
  clearAnalyticsPlaceHolders: PropTypes.func
};

export default DealsRatesGroup;



// WEBPACK FOOTER //
// ./src/components/DealsRatesGroup/DealsRatesGroup.js